import { render, staticRenderFns } from "./extraInfoPolize.vue?vue&type=template&id=52471147&"
import script from "./extraInfoPolize.vue.ts?vue&type=script&lang=ts&"
export * from "./extraInfoPolize.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports